function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "rect-1",
  width: 56,
  height: 56,
  x: 0,
  y: 0,
  rx: 0,
  ry: 0
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 56,
  x: 0,
  y: 0,
  fill: "black"
}), /*#__PURE__*/React.createElement("use", {
  fill: "white",
  xlinkHref: "#rect-1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "none",
  xlinkHref: "#rect-1"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h56v56H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "rgb(239,78,35)",
  fillRule: "evenodd",
  d: "M7.00002098 9.96335411l2.96333313-2.96333313 39.03666687 39.03665924-2.96333313 2.96333313-13.37000084-13.3699932v4.03666495c0 5.156662-4.17666435 9.33332825-9.33333015 9.33332825-5.15666771 0-9.33333493-4.17666626-9.33333493-9.33332825 0-5.1566677 4.17666722-9.33333206 9.33333493-9.33333206 1.703331 0 3.289999.48999977 4.66666603 1.28333283v-.65333367L7.00002099 9.96335411zm35.00006104 6.36999893h-9.33333016v7.42000008l-4.66666794-4.66666603V7.00002099h13.9999981v9.33333205z"
})));

var SvgMute = function SvgMute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mute.cace9b9c.svg";
export { ForwardRef as ReactComponent };